import Router from 'next/router'
import sortBy from 'lodash/sortBy'
import { setPageTitle } from './utils'
import { isFirstPage } from '../useHistoryState'
// import { isFirstPage, shouldIgnoreFirstPage } from "../hooks";

type ModalItem = {
  added_at: number
  closeCallback: () => void
}

class ModalService {
  static instance: ModalService

  private modals: Record<string, ModalItem> = {}

  private pageData = {
    url: '',
    title: '',
    state: '',
  }

  constructor() {
    if (!ModalService.instance) {
      ModalService.instance = this
    }
    return ModalService.instance
  }

  init = () => {
    Router.beforePopState((e) => {
      const modals = Object.values(this.modals)
      if (modals.length) {
        const activeModal = sortBy(modals, ['added_at'])[modals.length - 1]
        window.history.pushState(this.pageData.state, '', this.pageData.url)
        setPageTitle(this.pageData.title)
        activeModal.closeCallback()
        return false
      } else {
        const hash = Router.router?.asPath.replace(e.as, '')
        // Close the window when we are in the first page and no modal is open
        if (hash === '#modal') {
          window.history.back()
        }
      }
      return true
    })
  }

  off = () => {
    Router.beforePopState(() => true)
  }

  add = (id: string, closeCallback: ModalItem['closeCallback']) => {
    if (
      isFirstPage() &&
      Object.values(this.modals).length === 0 &&
      window.location.hash !== 'modal'
    ) {
      // if we are in first page and it's the first modal, add a hash state in history to handle modals of first rendered pages
      Router.push({ hash: 'modal' }).catch((e) => {
        // workaround for https://github.com/vercel/next.js/issues/37362
        if (!e.cancelled) {
          throw e
        }
      })
    }

    this.modals[id] = { added_at: new Date().getTime(), closeCallback }
    this.pageData = {
      url: window.location.href,
      title: document.title,
      state: window.history.state,
    }
  }

  remove = (id: string) => {
    if (this.modals[id]) {
      delete this.modals[id]
    }
  }
}

export const modalService = new ModalService()
